exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n   height: 3vh;\n   display: block;\n   margin: auto;\n}\n\n.card {\n    padding: 0;\n    margin: 0;\n}\n\n.row {\n    margin: 0;\n}\n\n.icons img{\n    margin-right: 0;\n}\n\n.icons {\n    padding-right: 0;\n}\n\n.col {\n    padding-left: 0;\n}\n\n.iconsLeft{\n    padding-left: 0;\n}\n\n.iconsLeft img {\n    margin-left: 0;\n}\n\n.graph{\n    height: 60vh;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/overview/overview.component.css
// module id = ../../../../../src/app/overview/overview.component.css
// module chunks = main